// ** MUI Imports
import Typography from '@mui/material/Typography'

interface Props {
  captionText: string
  boldText: string
}
const CustomDetail = (props: Props) => {
  return (
    <>
      <Typography variant='body2' letterSpacing={0} >
        {props.captionText}
      </Typography>
      <Typography variant='body1' fontWeight={600} letterSpacing={0} >
        {props.boldText}
      </Typography>
    </>
  )
}

export default CustomDetail
